/* tslint:disable */
/* eslint-disable */
/**
 * data-center
 * data-center
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DataCenterNavigation } from './DataCenterNavigation';
import {
    DataCenterNavigationFromJSON,
    DataCenterNavigationFromJSONTyped,
    DataCenterNavigationToJSON,
    DataCenterNavigationToJSONTyped,
} from './DataCenterNavigation';

/**
 * 
 * @export
 * @interface FindDataCenterNavigation200Response
 */
export interface FindDataCenterNavigation200Response {
    /**
     * 
     */
    data?: DataCenterNavigation;
}

/**
 * Check if a given object implements the FindDataCenterNavigation200Response interface.
 */
export function instanceOfFindDataCenterNavigation200Response(value: object): value is FindDataCenterNavigation200Response {
    return true;
}

export function FindDataCenterNavigation200ResponseFromJSON(json: any): FindDataCenterNavigation200Response {
    return FindDataCenterNavigation200ResponseFromJSONTyped(json, false);
}

export function FindDataCenterNavigation200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): FindDataCenterNavigation200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : DataCenterNavigationFromJSON(json['data']),
    };
}

export function FindDataCenterNavigation200ResponseToJSON(json: any): FindDataCenterNavigation200Response {
    return FindDataCenterNavigation200ResponseToJSONTyped(json, false);
}

export function FindDataCenterNavigation200ResponseToJSONTyped(value?: FindDataCenterNavigation200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': DataCenterNavigationToJSON(value['data']),
    };
}

